import styled from 'styled-components';

export const SInputToggle = styled.div<{
  isActive: boolean;
}>``;

export const SInputToggleLabel = styled.div<{
  isActive: boolean;
  isDisabled: boolean;
}>`
  align-items: center;
  display: flex;
  font-size: 14px;
  height: ${({ isActive }) => (isActive ? '32px' : '44px')};
  margin-bottom: ${({ isActive }) => (isActive ? '8px' : '0')};
  align-items: center;
  justify-content: space-between;
  line-height: 20px;
  width: 100%;

  > div {
    > p {
      &:first-child {
        color: #161d1f;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
      }

      &:last-child {
        margin-top: 4px;
        color: ${({ isDisabled }) => (isDisabled ? '#8090BB' : '#7a959f')};
        display: ${({ isActive }) => (isActive ? 'none' : 'block')};
      }
    }
  }

  > button {
    align-items: center;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    padding: 8px 8px;

    > span {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      color: ${({ isDisabled }) => (isDisabled ? '#8090BB' : '#5b36f2')};
    }

    &:not(:disabled):hover {
      background-color: #e2dffd;
    }

    &:not(:disabled):focus-visible,
    &:not(:disabled):active {
      background-color: #c6c0fc;
    }
  }
`;

export const SInputToggleInput = styled.div`
  > button {
    margin-top: 16px;
    padding: 12px 24px;
  }
`;
